import axios from '../../axios'



//获取驾校tree
export const getSchoolTree = (data) => {
  return axios({
    url: '/locationcar/getSchoolTree',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/locationcar/locationcar.js